/* oxlint-disable typescript/consistent-return, typescript/no-unsafe-return, typescript/no-unsafe-argument, typescript/prefer-nullish-coalescing */
import { safe } from '../../src/utils'
import { UFile } from '../../src/ufile/ufile'
// import { makeClientFetchWithTel } from '@w/tel' // TODO: fix

type Fetch = typeof fetch

let download = async ({
  url,
  onProgress,
  fetch = globalThis.fetch.bind(globalThis),
}: {
  url: string
  onProgress?: (progress: number) => void
  fetch?: Fetch
}) => {
  const response = await fetch(url)
  if (!response.ok) return

  const json = url.endsWith('.json')
  if (json && onProgress)
    throw new Error('onProgress not supported for json files')

  const totalDownloadBytes = response.headers.get('content-length')
  const type = response.headers.get('content-type')

  const path =
    response.headers.get('x-ufile-path') ?? url.split('/').pop() ?? undefined

  if (totalDownloadBytes === null || !onProgress) {
    if (json) return response.json() // we can parse dates here if needed
    return new UFile(await response.blob(), { path })
  }

  let bytesDownloaded = 0
  const reader = safe(response.body).getReader()

  const chunks: Uint8Array[] = []

  while (true) {
    const { value, done } = await reader.read()
    if (done) break

    bytesDownloaded += value.length
    chunks.push(value)
    onProgress(bytesDownloaded / Math.trunc(Number(totalDownloadBytes)))
  }

  // oxlint-disable-next-line typescript/no-explicit-any
  return new UFile(new Blob(chunks as any, { type: type || 'octet-stream' }), {
    path,
    // oxlint-disable-next-line typescript/no-explicit-any
  }) as any
}

export function setDownloadFunctionForTests(fn: typeof download) {
  download = fn
}

export function makeDownloadFile() {
  return function downloadFile<T = UFile>(
    url: string,
    opts?: { onProgress?: (progress: number) => void },
  ): Promise<T | undefined> {
    // const fetch = makeClientFetchWithTel('downloadFile') // TODO: fix
    return download({
      url,
      onProgress: opts?.onProgress,
      // oxlint-disable-next-line typescript/no-unnecessary-type-assertion
      fetch: fetch as Fetch,
      // oxlint-disable-next-line typescript/no-explicit-any
    }) as any
  }
}

export async function _downloadFakeFile(url: string) {
  const response = await fetch(url)
  if (!response.ok) throw new Error('Failed to download fake file')
  const blob = await response.blob()
  return new UFile(blob, { path: url.split('/').pop() })
}
